import React from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'

import { TextInput } from '@/modules/base/components/inputs'
import PageWrapper from '@/modules/base/components/modalWizard/pageWrapper'
import useCreateUser from './context'
import IconInfo from '@assets/images/icons/info-icon.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const ContactPerson = () => {
  const { client, patch } = useCreateUser()
  const classes = useStyles()

  const validationSchema = Yup.object({
    firstname: Yup.string().required(lang.emptyRequiredFieldErrorMessage),
    lastname: Yup.string().required(lang.emptyRequiredFieldErrorMessage),
    email: Yup.string().email(lang.invalidEmailErrorMessage).required(lang.emptyRequiredFieldErrorMessage),
  })

  return (
    <Formik
      initialValues={client}
      onSubmit={patch}
      enableReinitialize
      validationSchema={validationSchema}
      validateOnMount
    >
      {({ handleSubmit, isValid, values }) => {
        return (
          <PageWrapper
            heading={lang.createClient.contactPerson.heading}
            title={lang.createClient.contactPerson.title}
            text={lang.createClient.contactPerson.text}
            disabled={!isValid}
            onNextButtonClick={() => {
              handleSubmit()
              return isValid
            }}
            onBackButtonClick={() => {
              patch(values)
              return true
            }}
          >
            <Form className={classes.form}>
              <div className={classes.row}>
                <TextInput useFormik name="firstname" label={lang.firstNameLabel} />
                <TextInput useFormik name="lastname" label={lang.lastNameLabel} />
              </div>
              <div className={classes.row}>
                <TextInput useFormik type="email" name="email" label={lang.emailAddressTitle} />
              </div>
              <div className={classes.infoRow}>
                <SVGIcon svg={IconInfo} height="16px" width="16px" />
                <span>{lang.createClient.contactPerson.info}</span>
              </div>
            </Form>
          </PageWrapper>
        )
      }}
    </Formik>
  )
}

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    flexGrow: 1,
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    gap: 20,
    '& + $row': {
      marginTop: 20,
    },
  },
  infoRow: {
    color: theme.black,
    fontSize: 14,
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 10,
    '& + $row': {
      marginTop: 20,
    },
  },
}))

export default ContactPerson
